import { Card, CardBody, Text, Box, Flex, Icon, Textarea, Button, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { IoBanOutline, IoCheckmarkOutline, IoChevronForwardOutline, IoCloseCircleOutline } from "react-icons/io5";
import api from "../servicos/Api";

const Reunioes = () => {

    const [reunioes, setReunioes] = useState([]);
    const [reuniao, setReuniao] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [justificativa, setJustificativa] = useState('');
    const [aguarde, setAguarde] = useState(false);

    useEffect(() => {
        getReunioes();
    }, []);

    const getReunioes = async () => {
        const response = await api.get('/login_app/reunioes/0');
        if(response.data.error === false){
            setReunioes(response.data.data);
        }
    };

    const justificar = async () => {
        if(justificativa !== ''){
            setAguarde(true);
            const response = await api.post('/login_app/justificativa', {
                seq_conselho_reuniao: reuniao.seq_conselho_reuniao,
                justificativa: justificativa
            });

            if(response.data.error === false){
                getReunioes();
                setIsOpen(false);
            }
            setAguarde(false);
        }
    };

    const CardReuniao = (props) => {
        return(<Card key={'reuniao'+props.r.seq_conselho_reuniao} mb='1' onClick={props.r.situacao === 'pode_justificar' ? () => {setReuniao(props.r); setIsOpen(true);} : () => {}}>
                <CardBody>
                    <Flex justifyContent='space-between' alignItems='center'>
                        <Flex alignItems='center'>
                            <Box flexDirection='column'>
                                <Text textAlign='center' fontSize='md' fontWeight='bold' lineHeight='1' color='#00adee'>{props.r.dia}</Text>
                                <Text textAlign='center' fontSize='sm' fontWeight='bold'>{props.r.mes}</Text>
                            </Box>
                            <Text ml='4'>{props.r.titulo}</Text>
                        </Flex>
                        {props.r.situacao === 'presente' ? <Icon boxSize='5' color='green' as={IoCheckmarkOutline}/> :
                        props.r.situacao === 'pode_justificar' ? <Icon boxSize='5' as={IoChevronForwardOutline}/> : 
                        props.r.situacao === 'nao_pode_justificar' ? <Icon boxSize='5' as={IoBanOutline}/> : 
                        props.r.situacao === 'ja_justificou' ? <Icon boxSize='6' color='green' as={IoCloseCircleOutline}/> : ''}
                    </Flex>
                </CardBody>
            </Card>);
    };

    const ListaReunioes = (props) => {
        if(props.reunioes.length <= 0){
            return(<Text textAlign='center'>Buscando reuniões...</Text>);
        }
        var ano = props.reunioes[0].ano;

        return(<>
            {props.reunioes.map((r, i) => {
                if(i === 0){
                    return <>
                        <Text fontWeight='bold'>{r.ano}</Text>
                        <CardReuniao r={r}/>
                    </>
                }else{
                    if(r.ano === ano){
                        return <CardReuniao r={r}/>
                    }else{
                        ano = r.ano;
                        return <>
                            <Text fontWeight='bold'>{r.ano}</Text>
                            <CardReuniao r={r}/>
                        </>
                    }
                }
            })}
        </>)

    }

    // const ReuniaoDrawer = (props) => {
    //     return(
    //         <Drawer
    //             isOpen={props.isOpen}
    //             placement='right'
    //             onClose={props.onClose}
    //             size='lg'
    //         >
    //         <DrawerOverlay />
    //         <DrawerContent>
    //             <DrawerCloseButton />
    //             <DrawerHeader>Justificativa</DrawerHeader>

    //             <DrawerBody>
    //                 {reuniao !== null ? <>
    //                 <Text fontWeight='bold'>{props.reuniao.titulo}</Text>
    //                 <Text fontSize='sm' mb='2'>{props.reuniao.hora}</Text>
    //                 <Text mb='2'>Justifique sua ausência:</Text>
    //                 <Textarea mb='2' value={justificativa} onChange={e => setJustificativa(e.target.value)}></Textarea>
    //                 <Button colorScheme='blue' disabled={aguarde} size='lg' float='right'>Enviar</Button></> : ''}
    //             </DrawerBody>
    //         </DrawerContent>
    //         </Drawer>
    //     );
    // };

    return(
        <>
        <Box p='4'>
            <ListaReunioes reunioes={reunioes}/>
        </Box>
        <Drawer
                isOpen={isOpen}
                placement='right'
                onClose={() => setIsOpen(false)}
                size='lg'
            >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Justificativa</DrawerHeader>

                <DrawerBody>
                    {reuniao !== null ? <>
                    <Text fontWeight='bold'>{reuniao.titulo}</Text>
                    <Text fontSize='sm' mb='2'>{reuniao.hora}</Text>
                    <Text mb='2'>Justifique sua ausência:</Text>
                    <Textarea mb='2' value={justificativa} onChange={e => setJustificativa(e.target.value)}></Textarea>
                    <Button colorScheme='blue' disabled={aguarde} size='lg' float='right' onClick={() => justificar()}>Enviar</Button></> : ''}
                </DrawerBody>
            </DrawerContent>
            </Drawer>
        {/* <ReuniaoDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} reuniao={reuniao}/> */}
        </>
    );    
};

export default Reunioes;